// --- START OF FILE IndicacaoStyle.js ---

import styled from "styled-components";

export const IndicacaoContainer = styled.div`
    width: 100%;
    min-height: 100vh;
    padding: 40px;
    box-sizing: border-box;
    background-image: url('/textura.jpg');
    background-size: cover;
    background-attachment: fixed;
`;

export const ContentBox = styled.div`
    background: rgba(30, 30, 30, 0.9);
    backdrop-filter: blur(10px);
    border-radius: 8px;
    padding: 30px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
    max-width: 900px;
    margin: 0 auto;
`;

export const Header = styled.div`
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    
    h1 {
        margin: 0;
        color: #E6AA3A;
        font-size: 28px;
        text-align: center;
    }
`;

export const ClientSearch = styled.div`
    margin-bottom: 30px;

    h4 {
        margin: 0 0 15px 0;
        color: #fff;
        font-size: 18px;
        opacity: 0.9;
    }

    .inputBoxFilter {
        display: flex;
        
        input {
            flex-grow: 1;
            height: 45px;
            border: 1px solid rgba(255, 255, 255, 0.2);
            background: rgba(0,0,0,0.3);
            padding: 0 20px;
            color: #fff;
            border-radius: 6px 0 0 6px;
            &:focus { outline: none; border-color: #E6AA3A; }
        }
        
        button {
            width: 120px;
            height: 45px;
            border: none;
            background: #E6AA3A;
            color: #111;
            cursor: pointer;
            border-radius: 0 6px 6px 0;
            font-weight: 600;
        }
    }
`;

export const SearchArea = styled.div`
    margin-top: 20px;
    max-height: 350px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
`;

export const SearchedClients = styled.div`
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 6px;
    overflow: hidden;

    .columns, .row, .rowSelected {
        display: grid;
        grid-template-columns: 3fr 2fr 3fr;
        padding: 12px 15px;
        color: #fff;
        align-items: center;
    }

    .columns {
        font-weight: bold;
        background: rgba(0,0,0,0.2);
        border-bottom: 2px solid #E6AA3A;
    }
    .tabelona {
        max-height: 250px;
        overflow-y: auto;
    }
    .row {
        cursor: pointer;
        border-bottom: 1px solid rgba(255,255,255,0.1);
        &:hover { background: rgba(230, 170, 58, 0.1); }
    }
    .rowSelected {
        background: #E6AA3A;
        color: #111;
        font-weight: bold;
        grid-template-columns: 3fr 2fr 3fr auto;
    }
`;

export const QuandoDeseja = styled.div`
    margin-top: 30px;
    padding-top: 30px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;

    span {
        color: #fff;
        font-size: 18px;
        font-weight: 500;
    }

    input {
        height: 50px;
        width: 100%;
        max-width: 300px;
        border-radius: 6px;
        border: 1px solid rgba(255, 255, 255, 0.2);
        background: rgba(0,0,0,0.3);
        color: #fff;
        font-size: 22px;
        text-align: center;
        &:focus { outline: none; border-color: #E6AA3A; }
    }

    button {
        border: none;
        border-radius: 6px;
        padding: 12px 40px;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        background: #27ae60;
        color: #fff;
        transition: background 0.3s;
        &:hover { background: #2ecc71; }
    }
`;